/*
 * @Author: tao.zong
 * @Date: 2018-12-14 10:30:14
 * @Last Modified by: tao.zong
 * @Last Modified time: 2018-12-14 11:45:14
 * @webview 4.0.0以上版本，ios注册签到通知的方法
 */

import store from "@/store";

export class BackgroundCheckinNotiHandler { 
  
  private wordsForiOS = {
    continue: [
      {
        title: "NEW Daily Bonus",
        content:
          "Click!🎉 Claim your NEW Daily Bonus! 🎉 Today you will win @(coins) coins! >>"
      },
      {
        title: "A Gift For You!",
        content:
          "Hey, Click here for a special bonus reward! Get up tp @(coins) coins! 🎉 check out now>>"
      },
      {
        title: "Daily Bonus Coins",
        content:
          "Yikes!! Don’t miss the check-in reward today. Get up to @(coins) coins now!🎉"
      }
    ],
    bigBang: [
      {
        title: "Check-in Reminder",
        content:
          "7 days!!! A Grand Gift is waiting for you NOW. Don’t forget!!💪💪",
        image: "hy_ios_notice_bonus8"
      }
    ],
    disturb: [
      {
        title: "Daily Bonus Coins",
        content:
          "Get a Bigger Bonus every day! 🙌 Come and claim your reward!🤩 click>>"
      },
      {
        title: "Free Bonus Today",
        content: "Forgot something? Claim your FREE daily bonus NOW. 👉👉👉"
      },
      {
        title: "Daily Bonus Coins",
        content:
          "You haven’t claimed your daily bonus today. Would you like to do it right now? 👉👉👉"
      }
    ]
  };

  private imagesForiOS = [
    "hy_ios_notice_bonus1",
    "hy_ios_notice_bonus2",
    "hy_ios_notice_bonus3",
    "hy_ios_notice_bonus4",
    "hy_ios_notice_bonus5",
    "hy_ios_notice_bonus6",
    "hy_ios_notice_bonus7"
  ];

  public configNotification() {
    const { nextDay, disturbDays, lastCheckTime } = this.getCheckinState();
    const username: string = store.state.userList[0]
      ? store.state.userList[0].userName
      : "";
    if (this.getCheckinReward(1) === null) {
      return "";
    }

    const that = this;
    const DISTURB_TOP_DAY = 3; // 连续3天没签到则不发push
    const isDisturb: boolean = disturbDays > 0;
    if (disturbDays <= DISTURB_TOP_DAY) {
      let pushString = "";
      for (
        let index = 0;
        index < DISTURB_TOP_DAY - disturbDays + (isDisturb ? 0 : 1);
        index++
      ) {
        let pushContent = that.getPushContent(true, nextDay);
        const reward: any = this.getCheckinReward(isDisturb ? 1 : nextDay);
        if (index === 0) {
          if (!isDisturb) {
            pushContent = that.getPushContent(false, nextDay);
          } else {
            continue;
          }
        }

        const rewardContent = reward ? reward.reward : "";
        const timeVal = (index + 1) * 86400000;
        // const timeVal = (index + 1) * 10000 //测试用的
        const notificationData = {
          title: pushContent.title + " ".repeat(index), // iOS 根据title 作为通知的id，同一个id只能注册一个
          content: that.handlePushContent(
            pushContent.content,
            username,
            rewardContent
          ),
          imageUrl: pushContent.image,
          customData: { type: "checkin" },
          timeInterval: timeVal,
          badgeNumber: 0
        };
        pushString += timeVal ? "&" + JSON.stringify(notificationData) : "";
      }
      return pushString;
    } else {
      return "";
    }
  }

  /**
   *
   * @param day 下一天签到的天数
   */
  private getCheckinReward(day: number) {
    const array = (store.state.settingModule && store.state.settingModule.settingData)
        ? store.state.settingModule.settingData.checkin_rewards
        : store.state.initialSettingModule.initialSetting.checkin_rewards;

    if (array === undefined || array === null) {
      return null;
    }
    const reward = array.find((r: any) => {
      return r.checkin_days === day;
    });
    return reward;
  }

  private getPushContent(isDisturb: boolean, day: number) {
    const words: any = this.wordsForiOS;
    const array: any =
      isDisturb === true
        ? words.disturb
        : day === 7
          ? words.bigBang
          : words.continue;
    const dict: any = this.getRandomItem(array);
    if (!dict.hasOwnProperty("image")) {
      dict.image = this.getRandomItem(this.imagesForiOS);
    }
    return dict;
  }

  private getCheckinState() {
    const userinfo: any = store.state.gxUserInfoModule.gxUserInfo;
    if (
      userinfo !== null &&
      userinfo !== undefined &&
      userinfo.hasOwnProperty("continuous_checkin_days") &&
      userinfo.hasOwnProperty("last_checkin_time")
    ) {
      const days = this.daysBetween(
        new Date().valueOf(),
        userinfo.last_checkin_time
      );

      let nextDay: number = 1;
      const disturbDays: number = days;
      if (days <= 1) {
        nextDay = userinfo.continuous_checkin_days % 7;
        nextDay += 1;
      } else {
        nextDay = 1;
      }

      return {
        nextDay,
        lastCheckTime: userinfo.last_checkin_time,
        disturbDays
      };
    }
    return {
      nextDay: 1,
      lastCheckTime: new Date().valueOf(),
      disturbDays: 0
    };
  }

  private daysBetween = (d1: number, d2: number) =>
    Math.floor(Math.abs((d1 - d2) / 1000) / 86400);
  private handlePushContent = (
    content: string,
    usrename: string,
    coins: number
  ) =>
    content
      .replace("@(username)", usrename)
      .replace("@(coins)", coins.toString());
  private getRandomItem = (array: any[]) =>
    array[Math.floor(Math.random() * array.length)];
}

const backgroundCheckinNotiHandler = new BackgroundCheckinNotiHandler();
export default backgroundCheckinNotiHandler;
